import {
    IonButton,
    IonButtons,
    IonCol,
    IonHeader,
    IonRow,
    IonToolbar,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Event, EventEntry } from "../../../../models";
import EditEntrySelectedRiderCard from "./EntryRiderInfo/EditEntrySelectedRiderCard";
import EditEntryRiderDetailsCard from "./EntryRiderInfo/EditEntryRiderDetailsCard";
import EditEntryRiderMembershipsCard from "./EntryRiderInfo/EditEntryRiderMembershipsCard";

interface _Props {
    entry: EventEntry
    event?: Event
    onChange?: (updatedEventEntry: EventEntry) => void
}

const EditRiderTab: React.FC<_Props> = ({event, entry, onChange}) => {

    const [currentEntry, setCurrentEntry] = useState<EventEntry | null | undefined>(entry);
    const [currentActiveBtn, setCurrentActiveBtn] = useState("1");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        
    }, [entry]);

    const handleUpdatedEntry = (updatedEventEntry: EventEntry) => {
        setCurrentEntry(updatedEventEntry);
        if (onChange) onChange(updatedEventEntry);
    }

    return (
        <>
            {event?.entryOptions?.displayRider2Input && (
                <IonHeader id="selectRiderMenu">
                    <IonToolbar id="selectRiderMenu" color="light">
                        <div className="scrollmenu">
                            <IonButtons>
                                <IonButton onClick={() => setCurrentActiveBtn("1")}>
                                    <p className={"text-capitalize " + (currentActiveBtn === "1" ? "active-border" : "")}>
                                        Rider #1
                                    </p>
                                </IonButton>
                                <IonButton onClick={() => setCurrentActiveBtn("2")}>
                                    <p className={"text-capitalize " + (currentActiveBtn === "2" ? "active-border" : "")}>
                                        Rider #2
                                    </p>
                                </IonButton>
                            </IonButtons>
                        </div>
                    </IonToolbar>
                </IonHeader>
            )}
            {currentEntry ?
                <IonRow>
                    <IonCol sizeXs="12" sizeMd="6">
                        <EditEntrySelectedRiderCard entry={currentEntry} isSecondRider={currentActiveBtn === "2"} onSubmit={(updatedEntry: EventEntry) => handleUpdatedEntry(updatedEntry)}/>
                    </IonCol>
                    <IonCol sizeXs="12" sizeMd="6">
                        <EditEntryRiderDetailsCard entry={currentEntry} isSecondRider={currentActiveBtn === "2"} onChange={(updatedEntry: EventEntry) => handleUpdatedEntry(updatedEntry)} />
                    </IonCol>
                    <IonCol sizeXs="12" sizeMd="12">
                        {event ?
                            <EditEntryRiderMembershipsCard event={event} entry={currentEntry} isSecondRider={currentActiveBtn === "2"} />
                            :
                            <p>Could not load the memberships.</p>
                        }
                    </IonCol>
                </IonRow>
                :
                <p>No entry found.</p>
            }
        </>
    );
};

export default EditRiderTab;